import { render } from "./ApproveGatepass.vue?vue&type=template&id=216c237f&scoped=true"
import script from "./ApproveGatepass.vue?vue&type=script&lang=js"
export * from "./ApproveGatepass.vue?vue&type=script&lang=js"

import "./ApproveGatepass.vue?vue&type=style&index=0&id=216c237f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216c237f"]])

export default __exports__